import { Module } from "vuex";

export const Elfrom: Module<any, any> = {
  state: {
    queryElform: {},
    currentPageElform: {},
  },
  getters: {
    queryElform: (state) => state.query,
    currentPageElform: (state) => state.query,
  },
  mutations: {
    setqueryElform(state, data) {
      state.queryElform = data;
    },
    setcurrentPageElform(state, data) {
      state.currentPageElform = data;
    },
  },
  actions: {
    setcurrentPageElform(data) {
      console.log(data);
      data.commit("setcurrentPageElform");
    },
    setqueryElform(query) {
      query.commit("setqueryElform");
    },
  },
};
